/** 海报选择 */

import { FC } from 'react';
import { SecondDialogProps } from '../CopyLinkDialog';
import PosterShareModal from 'src/pages/share-poster/components/SharePosterModal';

export const PosterDialog: FC<SecondDialogProps> = ({ event, visible, onBack, onClose }) => (
  <PosterShareModal visible={visible} onClose={onClose} event={event} onBack={onBack} />
);
